import logo from '../logom.svg'
import Navbar  from 'react-bootstrap/Navbar'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import React from 'react'
import { withRouter, NavLink} from 'react-router-dom';
import Nav from 'react-bootstrap/Nav'

class NavbarM extends React.Component{

    constructor(props){
        super(props);
        var user = localStorage.getItem("username");
        this.state = {
            username: user
        }
    }
    onLogout(e,event){
        localStorage.removeItem('token')
        e.props.history.push('/login')
    }
    render(){
        
        if(this.props.user=== 1){
            return (
                <div >
                    <Navbar/>
                    <Navbar bg="dark" expand="lg" variant="dark" fixed="top">
                        <Navbar.Brand>
                                <img
                                    alt=""
                                    src={logo}
                                    height="30"
                                    className="d-inline-block align-top"
                                />{' '}
                                </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="mr-auto">
                                <NavLink className="navbarLink"  to="/">დავალებები</NavLink>
                                <NavLink  className="navbarLink" to="/insert">დამატება</NavLink>
                            </Nav>
                            <label className="usernameLabel">{this.state.username}</label>
                            <Form inline>
                                <Button variant="outline-light" onClick= {(event)=>this.onLogout(this,event)}>გასვლა</Button>
                            </Form>
                        </Navbar.Collapse>
                    </Navbar>
                </div>
            )
        }else if(this.props.user === 0){
            return (
                <div >
                    <Navbar/>
                    <Navbar bg="dark" expand="lg" variant="dark" fixed="top">
                    <Navbar.Brand>
                            <img
                                alt=""
                                src={logo}
                                height="30"
                                className="d-inline-block align-top"
                            />{' '}
                            </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto">
                            <NavLink to="/" className="navbarLink">დავალებები</NavLink>
                        </Nav>
                        <label className="usernameLabel">{this.state.username}</label>
                        <Form inline> 
                            <Button variant="outline-light" onClick= {(event)=>this.onLogout(this,event)}>გასვლა</Button>
                        </Form>
                        
                    </Navbar.Collapse>
                    </Navbar>
                </div>
            )
        }
        
    }
}
export default withRouter(NavbarM) ;